<template>
    <div>
        <v-row>
            <v-col cols="12">
                <div class="headline">Fahrzeuge</div>
                <v-card>
                    <v-card-title>
                      <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="far fa-search"
                                label="Suchen"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="tables.vehicle.header"
                            :items="vehicle"
                            :search="search"
                            class="mb-4"
                            no-data-text="Keine Fahrzeuge vorhanden"
                            :items-per-page="15"
                      >
                      <template v-slot:item.color="{ item }">
                        <v-btn :color="'#' + item.color" depressed>&nbsp;</v-btn>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-btn icon class="mx-0" @click="editItem(item)">
                          <v-icon>far fa-edit</v-icon>
                        </v-btn>
                        <v-btn icon class="mx-0" @click="deleteItem(item)">
                          <v-icon>far fa-trash</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                </v-card>
              <v-card-actions>
                <v-btn color="primary" dark class="mb-2" @click="editItem(defaultItem)">Neues Fahrzeug</v-btn>
              </v-card-actions>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline" v-if="isNewElement">Neues Fahrzeug</span>
                    <span class="headline" v-else>Fahrzeug bearbeiten</span>
                </v-card-title>
                <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Name" v-model="editedItem.title"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                              Farbe
                              <v-color-picker
                                class="ma-2"
                                :swatches="swatches"
                                show-swatches
                                hide-canvas
                                hide-inputs
                                hide-sliders
                                v-model="editedItem.color"
                              ></v-color-picker>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="8">
                              <v-text-field label="Maximale Auslastung" v-model="editedItem.maxWeight"></v-text-field>
                            </v-col>
                            <v-col cols="4">

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">

                            </v-col>
                        </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="close">Abbrechen</v-btn>
                    <v-btn text color="primary" @click.native="save">Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'Companies',
  computed: {
    vehicle () {
      return this.$store.state.vehicle.all
    },
    isNewElement () {
      return this.editedItem.id === 0
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  data: () => ({
    swatches: [
      ['#CCCC99', '#CCCC66', '#CCCCCC'],
      ['#99CCCC', '#66CCCC', '#CC9999'],
      ['#99CC99', '#00FF99', '#00CCFF'],
      ['#99CCFF', '#CCCCFF', '#FFCCCC'],
      ['#FFCC99', '#FFCC66', '#FF9999']
    ],
    dialog: false,
    editedIndex: -1,
    editedItem: {
      id: 0,
      title: '',
      color: '',
      maxWeight: 0
    },
    defaultItem: {
      id: 0,
      title: '',
      color: '',
      maxWeight: 0
    },
    search: '',
    tables: {
      vehicle: {
        header: [
          {text: 'Name', value: 'title'},
          {text: 'Farbe', value: 'color'},
          {text: 'Maximale Auslastung', value: 'maxWeight'},
          {text: 'Aktionen', sortable: false, value: 'action'}
        ]
      }
    }
  }),
  methods: {
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    save () {
      if (this.isNewElement) {
        this.$store.commit('addVehicle', this.editedItem)
      } else {
        this.$store.commit('updateVehicle', this.editedItem)
      }
      this.close()
    },
    deleteItem (item) {
      this.$store.commit('delVehicle', item)
    }
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";
</style>



// WEBPACK FOOTER //
// src/components/Vehicle.vue